import React, { useState, forwardRef } from 'react';
import { UserMenu, Logout, useUserMenu } from 'react-admin';
import { MenuItem, ListItemIcon } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { ChangePasswordDialog } from '../dialogs/ChangePasswordDialog';
import { useTranslation } from 'react-i18next';

const ChangePasswordMenuItem = forwardRef<HTMLLIElement, { onOpenDialog: () => void }>(
  ({ onOpenDialog, ...props }, ref) => {
    const { onClose } = useUserMenu() ?? {};
    const { t } = useTranslation();

    const handleClick = () => {
      onClose?.();

      setTimeout(() => {
        onOpenDialog();
      }, 200);
    };

    return (
      <MenuItem ref={ref} onClick={handleClick} {...props}>
        <ListItemIcon>
          <LockOutlinedIcon fontSize="small" />
        </ListItemIcon>
        {t('members.changePassword')}
      </MenuItem>
    );
  },
);

const ProfileMenu = (props: any) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  return (
    <>
      <UserMenu
        {...props}
        // icon={
        //     <Badge
        //         color="error"
        //         variant="dot"
        //         invisible={!hasUnread || isVendor}
        //     >
        //         <AccountCircleIcon />
        //     </Badge>
        // }
      >
        {/*{!isVendor && <MenuItem onClick={() => navigate("/support")} {...props}>*/}
        {/*    {t('resources.support')}*/}
        {/*</MenuItem> }*/}
        <ChangePasswordMenuItem onOpenDialog={() => setDialogOpen(true)} />
        <Logout />
      </UserMenu>
      <ChangePasswordDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
    </>
  );
};

export default ProfileMenu;
